import { AllCallsConstants } from '../Constants';
import { adminUsersServices } from '../Services';

export const allCallActions = {
    searchAllCall
};

function searchAllCall(data: any) {
    return (dispatch:any) => {
        dispatch(dispatchFunction({
            type: AllCallsConstants.SEARCH_ALLCALL_REQUEST,
            data: null
        }));
        adminUsersServices.AllCall(data)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: AllCallsConstants.SEARCH_ALLCALL_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: AllCallsConstants.SEARCH_ALLCALL_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: AllCallsConstants.SEARCH_ALLCALL_FAILURE,
                        data: error.message
                    }));
                }
            );
    };
}

function dispatchFunction(data: any) {
    // To do: check for refresh / unauthorized error
    return {
        type: data.type,
        data: data.data
    };
}